import Big from 'big.js'
import { PAYMENT_ROUNDING, PAYMENT_ROUNDING_DIRECTION } from 'utils/constants'

/** Rounds the provided value to smallestUnit using the selected rounding direction */
const roundTo = (value: Big, smallestUnit: Big, roundingDirection: PAYMENT_ROUNDING_DIRECTION): Big => {
  let roundMode
  switch (roundingDirection) {
    case PAYMENT_ROUNDING_DIRECTION.NEAREST:
      roundMode = Big.roundHalfUp
      break
    case PAYMENT_ROUNDING_DIRECTION.UP:
      roundMode = Big.roundUp
      break
    case PAYMENT_ROUNDING_DIRECTION.DOWN:
      roundMode = Big.roundDown
      break
  }

  return value.div(smallestUnit).round(0, roundMode).mul(smallestUnit)
}

/** Gets the delta between the provided amount and the rounded amount given the rounding method
 *  Note: this function is expected to be used for currency amounts, so it requires the input to have 2 decimals
 * */
export const getRoundingDelta = (
  amount: Big,
  roundingMethod: PAYMENT_ROUNDING,
  roundingDirection?: PAYMENT_ROUNDING_DIRECTION,
): Big => {
  // Log a warning if the amount has more than 2 decimals
  if (!amount.round(2).sub(amount).eq(0)) {
    console.warn(`Amount ${amount} has more than 2 decimals`)
    // also log stack trace for easier debugging
    console.trace()
  }

  if (roundingDirection === undefined) {
    roundingDirection = PAYMENT_ROUNDING_DIRECTION.NEAREST
  }

  switch (roundingMethod) {
    case PAYMENT_ROUNDING.ONE:
    case PAYMENT_ROUNDING.POINT_ONE:
    case PAYMENT_ROUNDING.POINT_FIVE:
    case PAYMENT_ROUNDING.POINT_TWO_FIVE:
    case PAYMENT_ROUNDING.POINT_ZERO_FIVE:
      return roundTo(amount, Big(roundingMethod), roundingDirection).sub(amount)

    case PAYMENT_ROUNDING.ZERO:
      return Big(0)
  }
}
